import { pricesConverter } from "../AveFlow/AveFlow.util";
import { ITripSelectedDetails } from "models/TripInterface";
import { formatPrice } from "../TripSelector/TripSelector.service";
import { convertLegIdsToNumbers } from "../TripSelector/TripSelector.util";



/**
 * Funcion donde añadimos el objeto del descuento
 * @param price
 * @returns
 */
export function setApplyDiscount(
    tripSelectedDetails: ITripSelectedDetails,
    priceDiscount: number,
    nameDiscount: String,
    isPost: boolean,
    typeTrip: String,
    idLeg: any,
    newPrice: any,
    t: any,
    type:any,
    isRoundTrip:boolean,
    newPriceString?:any
  ) {
    if (typeTrip === "departure") {
      const aux = {
        ...tripSelectedDetails,
        body: {
          ...tripSelectedDetails.body,
          //travellers: [{ ...tripSelectedDetails.body.travellers }],
          outwardJourney: {
            trip: { ...tripSelectedDetails.body.outwardJourney?.trip },
            selectedTariff:
              tripSelectedDetails.body.outwardJourney?.selectedTariff.map(
                (item: any, i: any) => {
                  if (item.idLeg === convertLegIdsToNumbers(idLeg)) {
                    return {
                      ...item,
                      tickets: item?.tickets.map((ex: any,index:any) => {
                        if(item?.tickets[index]?.extras){
                          if(item?.provider==="renfe-ave"){
                            if(index===0){
                              return{
                                ...ex,
                                extras:ex.extras.concat(
                                  {
                                    amount: priceDiscount,
                                    value: nameDiscount,
                                    discountType:type,
                                    type: "DISCOUNT",
                                  }
                                ),
                            }
                            }else{
                              return{
                                ...ex,
                            }
                            }
                          
                          }else{
                          return{
                            ...ex,
                            extras:ex.extras.concat(
                              {
                                amount: priceDiscount,
                                value: nameDiscount,
                                discountType:type,
                                type: "DISCOUNT",
                              }
                            ),
                        }}
                        }else{
                          return{
                            ...ex,
                            extras: [
                              {
                                amount: priceDiscount,
                                value: nameDiscount,
                                discountType:type,
                                type: "DISCOUNT",
                              },
                            ],}
                        }
                      })
                    };
                  } else {
                    return {
                        ...item,
                        tickets: item?.tickets.map((ex: any,index:any) => {
                          if(item?.tickets[index]?.extras){
                            return{
                              ...ex,
                              extras:ex.extras,
                          }
                          }else{
                            return{
                              //...ex,
                              context:ex.context
                              }
                          }
                        })
                    };
                  }
                }
              ),
          },
        },
  
        summaryAmount: {
          departure: {
            ...tripSelectedDetails?.summaryAmount?.departure,
            transports:tripSelectedDetails?.summaryAmount?.departure?.transports.map((item: any) => {
              if(item.idTariff===convertLegIdsToNumbers(idLeg) ){
                return{
                  ...item,
                  discountApplied:true
                }
              }
              else{
                return{
                ...item
                }
              }
            }), 
            desglose: {
              ...tripSelectedDetails?.summaryAmount?.departure?.desglose,
              //now: `${formatPrice(nowNumber-priceDiscount)} €`,
              //totalAux: `${formatPrice(discount)} €`,
              literal: isPost ? "aprox." : "",
              isRoundTrip:isRoundTrip,
              discount: {
                value: `-${formatPrice(priceDiscount)} €`,
                title: t("desgloseModal.discount") + " " + nameDiscount,
                amount: priceDiscount,
              },
            },
          },
        },
      };
      return aux;
    } else if (typeTrip === "arrival") {
      const aux = {
        ...tripSelectedDetails,
        body: {
          ...tripSelectedDetails.body,
          returnJourney: {
            trip: { ...tripSelectedDetails.body.returnJourney?.trip },
            selectedTariff:
              tripSelectedDetails.body.returnJourney?.selectedTariff.map(
                (item: any, i: any) => {
                  if (item.idLeg === idLeg) {
                    return {
                      ...item,
                      tickets: item?.tickets.map((ex: any,index:any) => {
                        if(item?.tickets[index]?.extras){
                          if(item?.provider==="renfe-ave"){
                            if(index===0){
                              return{
                                ...ex,
                                extras:ex.extras.concat(
                                  {
                                    amount: priceDiscount,
                                    value: nameDiscount,
                                    discountType:type,
                                    type: "DISCOUNT",
                                  }
                                ),
                            }
                            }else{
                              return{
                                ...ex,
                            }
                            }
                          
                          }else{
                          return{
                            ...ex,
                            extras:ex.extras.concat(
                              {
                                amount: priceDiscount,
                                value: nameDiscount,
                                discountType:type,
                                type: "DISCOUNT",
                              }
                            ),
                        }}
                        }else{
                          return{
                            ...ex,
                            extras: [
                              {
                                amount: priceDiscount,
                                value: nameDiscount,
                                discountType:type,
                                type: "DISCOUNT",
                              },
                            ],}
                        }
                      })
                    };
                  } else {
                    return {
                        ...item,
                        tickets: item?.tickets.map((ex: any,index:any) => {
                          if(item?.tickets[index]?.extras){
                            return{
                              ...ex,
                              extras:ex.extras,
                          }
                          }else{
                            return{
                              //...ex,
                              context:ex.context
                              }
                          }
                        })
                  
                      /*tickets: [
                        {
                          ...item.tickets[0],
                          extras: [],
                        },
                      ],*/
                    };
                  }
                }
              ),
          },
        },
        summaryAmount: {
          arrival: {
            ...tripSelectedDetails?.summaryAmount?.arrival,
            transports:tripSelectedDetails?.summaryAmount?.arrival?.transports.map((item: any) => {
              if(item.idTariff===idLeg ){
                return{
                  ...item,
                  discountApplied:true
                }
              }
              else{
                return{
                ...item
                }
              }
            }), 
            desglose: {
              ...tripSelectedDetails?.summaryAmount?.arrival?.desglose,
              literal: isPost === true ? "aprox." : "",
              //totalAux: `${formatPrice(discount)} €`,
              isRoundTrip:isRoundTrip,
              discount: {
                value: `-${formatPrice(priceDiscount)} €`,
                title: t("desgloseModal.discount") + " " + nameDiscount,
                amount: priceDiscount,
              },
            },
          },
        },
      };
  
      return aux;
    }
  }
  
  /**
   * Funcion donde eliminamos el objeto del descuento
   * @param price
   * @returns
   */
  export function setDeleteDiscount(
    tripSelectedDetails: ITripSelectedDetails,
    typeTrip: String
  ) {
    
    if (typeTrip === "departure") {
      const aux = {
        ...tripSelectedDetails,
        body: {
          ...tripSelectedDetails.body,
          outwardJourney: {
            trip: { ...tripSelectedDetails.body.outwardJourney?.trip },
            selectedTariff:
              tripSelectedDetails.body.outwardJourney?.selectedTariff.map(
                (item: any) => {
                  return {
                    ...item,
                    tickets: item?.tickets.map((ex: any,index:any) => {
                      return{
                        ...ex,
                        extras: item?.tickets[index]?.extras?.map((ex: any) => {
                          if (ex.discountType !== "DOCO" && ex.discountType !== "COUPON" && ex.discountType !== "DISCOUNT_CODE"  ) {
                            return{
                              ...ex
                            }
                          }
                      }).filter(Boolean)}
                     
                    }),  
                    
                    
                    /* [
                      {
                        ...item.tickets[index],
                        extras: item?.tickets[index]?.extras?.map((ex: any) => {
                          if (ex.discountType !== "DOCO") {
                            return{
                              ...ex
                            }
                          }
                         
                        }).filter(Boolean),
                      },
                    ], */
                  };
                }
              ),
          },
        },
        summaryAmount: {
          departure: {
            ...tripSelectedDetails?.summaryAmount?.departure,
            transports:tripSelectedDetails?.summaryAmount?.departure?.transports.map((item: any) => {
              return{
                ...item,
                discountApplied:false
              }
            }), 
            
            desglose: {
              now: tripSelectedDetails?.summaryAmount?.departure?.desglose?.now,
              later:
                tripSelectedDetails?.summaryAmount?.departure?.desglose?.later,
              total:
                tripSelectedDetails?.summaryAmount?.departure?.desglose?.total,
              aproxPrice:
                tripSelectedDetails?.summaryAmount?.departure?.desglose
                  ?.aproxPrice,
              totalAux:
                tripSelectedDetails?.summaryAmount?.departure?.desglose?.totalAux,
              literal:
                tripSelectedDetails?.summaryAmount?.departure?.desglose?.literal,
            },
          },
        },
      };
  
      return aux;
    } else if (typeTrip === "arrival") {
      const aux = {
        ...tripSelectedDetails,
        body: {
          ...tripSelectedDetails.body,
          returnJourney: {
            trip: { ...tripSelectedDetails.body.returnJourney?.trip },
            selectedTariff:
              tripSelectedDetails.body.returnJourney?.selectedTariff.map(
                (item: any) => {
                  return {
                    ...item,
                    tickets: item?.tickets.map((ex: any,index:any) => {
                      return{
                        ...ex,
                        extras: item?.tickets[index]?.extras?.map((ex: any) => {
                          if (ex.discountType !== "DOCO" && ex.discountType !== "COUPON" && ex.discountType !== "DISCOUNT_CODE" ) {
                            return{
                              ...ex
                            }
                          }
                      }).filter(Boolean)}
                     
                    }),  
                  };
                }
              ),
          },
        },
        summaryAmount: {
          arrival: {
            ...tripSelectedDetails?.summaryAmount?.arrival,
            transports:tripSelectedDetails?.summaryAmount?.arrival?.transports.map((item: any) => {
              return{
                ...item,
                discountApplied:false
              }
            }), 
            desglose: {
              now: tripSelectedDetails?.summaryAmount?.arrival?.desglose?.now,
              later: tripSelectedDetails?.summaryAmount?.arrival?.desglose?.later,
              total: tripSelectedDetails?.summaryAmount?.arrival?.desglose?.total,
              aproxPrice:
                tripSelectedDetails?.summaryAmount?.arrival?.desglose?.aproxPrice,
              totalAux:
                tripSelectedDetails?.summaryAmount?.arrival?.desglose?.totalAux,
              literal:
                tripSelectedDetails?.summaryAmount?.arrival?.desglose?.literal,
            },
          },
        },
      };
  
      return aux;
    }
  }
  
  export function calculoDescuento(
    getPriceTrip: number,
    getPriceButton: number,
    priceDiscount: number
  ) {
    let resultadoBoton = 0;
    let resultadoTotal = 0;
  
    if (Math.sign(getPriceButton - priceDiscount) !== 1) {
      //Descuento negativo
      resultadoBoton = 0;
    } else {
      //Descuento positivo
      resultadoBoton = getPriceButton - priceDiscount;
    }
  
    if (Math.sign(getPriceTrip - priceDiscount) !== 1) {
      //Descuento negativo
      resultadoTotal = 0;
    } else {
      //Descuento positivo
      resultadoTotal = getPriceTrip - priceDiscount;
    }
  
    return { resultadoBoton, resultadoTotal };
  }
  
  
  export function calculoDescuentoPorRuta(price: number, priceDiscount: number) {
    let resultado = 0;
  
    if (Math.sign(price - priceDiscount) !== 1) {
      //Descuento negativo
      resultado = 0;
    } else {
      //Descuento positivo
      resultado = price - priceDiscount;
    }
    return resultado;
  }
  
  export function checkIsPost(filter: any) {
    let getPriceTrip = 0;
    let routeSelectPrice;
    let isPost = false;
    if (filter.line==="Bolt" ) {
      //getPriceTrip = priceStringToNumber(filter.substring(7));
      //routeSelectPrice = priceStringToNumber(filter.substring(7));
      getPriceTrip=filter.priceNumber
      routeSelectPrice=filter.priceNumber
      isPost = true;
    } else {
      getPriceTrip=filter.priceNumber
      routeSelectPrice=filter.priceNumber
    }
  
    return { getPriceTrip, routeSelectPrice, isPost };
  }
  
  export function updatePriceButtons(
    discountToApply: any,
    getPriceTotal: any,
    getPriceButton: any,
    routeSelectPrice: any,
    priceDiscount: any,
    isPost: boolean,
    getTotalTrip?: any,
    isIdaVuelta?:any
  ) {
    let priceTotal = getPriceTotal,
      priceButton = getPriceButton,
      totalIdaVuelta = 0;
    if (discountToApply === 0) {
      priceTotal = (getPriceTotal - routeSelectPrice).toFixed(2);
      if (isPost) {
     if(isIdaVuelta===true){
          totalIdaVuelta = pricesConverter(getTotalTrip)-routeSelectPrice
        }else{
          totalIdaVuelta = 0;
        }
      } else {
        priceButton = getPriceButton - routeSelectPrice;
        if(isIdaVuelta===true){
          totalIdaVuelta = pricesConverter(getTotalTrip)-routeSelectPrice
        }else{
          totalIdaVuelta = 0;
        }
  
      }
    } else {
      priceTotal = (getPriceTotal - priceDiscount).toFixed(2);
      if (isPost) {
        totalIdaVuelta = pricesConverter(getTotalTrip) - priceDiscount;
      } else {
        totalIdaVuelta = pricesConverter(getTotalTrip) - priceDiscount;
        priceButton = getPriceButton - priceDiscount;
      }
    }
  
    return { priceTotal, priceButton, totalIdaVuelta };
  }
  
  
  
  /**
   *  mediante su id obtener el idLeg y el precio del pst que hemos pinchado
   * @param e 
   * @param transportsDocoDiscountIda 
   * @param transportsDocoDiscountVuelta 
   * @param saveSelectedPst 
   * @returns 
   */
  export function getIdPricePst(e: any,transportsDocoDiscountIda:any,transportsDocoDiscountVuelta:any,saveSelectedPst:any) {
    let typeSelectedTrip, idLeg=null,pstPrice;
  if(e.tabs==="tab1"){
    if(e.travelSelected!=undefined){
      idLeg=transportsDocoDiscountIda[e.travelSelected].idLeg
      pstPrice=transportsDocoDiscountIda[e.travelSelected].price
    }else{
      idLeg=saveSelectedPst?.idLeg as any
      pstPrice=saveSelectedPst.price
    }
    typeSelectedTrip={type:'departure'}
  }else{
    if(e.travelSelected!=undefined){
      idLeg=transportsDocoDiscountVuelta[e.travelSelected].idLeg
      pstPrice=transportsDocoDiscountVuelta[e.travelSelected].price
    }else{
      idLeg=saveSelectedPst?.idLeg as any
      pstPrice=saveSelectedPst.price
    }
    typeSelectedTrip={type:'arrival'}
  }
  
  return { typeSelectedTrip, idLeg, pstPrice };
  }
  
  /**
   * Para obtener el provider, su precio y buscar su descuentos
   * @param selectedPst 
   * @param transportsDocoDiscountIda 
   * @param transportsDocoDiscountVuelta 
   */
  export function getPstByIdLeg(selectedPst:any,transportsDocoDiscountIda:any,transportsDocoDiscountVuelta:any){
    let transport, price
    if(selectedPst?.transport){
      transport=supplierMappingDiscounts(selectedPst?.transport)
    }else{
      if(selectedPst?.tabs==="tab1"){
        transport=supplierMappingDiscounts(transportsDocoDiscountIda[selectedPst?.travelSelected].transport)
        price=transportsDocoDiscountIda[selectedPst?.travelSelected].priceNumber
      }else{
        transport=supplierMappingDiscounts(transportsDocoDiscountVuelta[selectedPst?.travelSelected].transport)
        price=transportsDocoDiscountVuelta[selectedPst?.travelSelected].priceNumber
   
      }
    }
  return {transport,price}
  }
  
  export function isRoundTrip(transportsDocoDiscountIda:any,transportsDocoDiscountVuelta:any){
    let result=false;
  if(transportsDocoDiscountIda && transportsDocoDiscountVuelta){
     result=true;
  }
  
    return result
  
  }


  /**
 * Funcion para sumar todos los precios de trenes y obtener el idTariff mas alto (segun su precio base)
 * @param array 
 * @returns 
 */
export function sumAndFindMax(array:any,t:any) {
    let key="price";
    // Variable para almacenar la suma total
    let totalSum = 0;
    // Variables para almacenar el valor máximo y su índice
    let maxObject =[] as any;
    let maxValue = -Infinity;
  
    // Iterar sobre cada objeto en el array
    array.forEach((obj:any) => {
      //maxObject.length=0
      // Sumar el valor del objeto al total
      totalSum += pricesConverter(obj[key]);
      // Comprobar si el valor actual es mayor que el máximo encontrado hasta ahora
      if (pricesConverter(obj[key]) > maxValue) {
        maxValue = pricesConverter(obj[key]);
        maxObject.push( {
          ...obj,
          route:t("train"),
          transport:t("renfeTitle"),
        });
      }else if(pricesConverter(obj[key]) === maxValue /*&& obj.isRoundTrip===true*/){
        maxObject.push( {
          ...obj,
          route:t("train"),
          transport:t("renfeTitle"),
        });
      }
    });
  
  
  
    // Devolver un objeto con la suma total y el objeto con el valor máximo
    return  maxObject.map((ex: any) => {
                      return{
                        ...ex,
                price:`${formatPrice(totalSum)} €`
                
       }})
      
  }

  
export function supplierMappingDiscounts(transport:any,){
    let result="";
    switch (transport) {
      case 'Cercanias':
      case 'AVANT':
      case 'AVE Larga distancia':
      case 'Renfe':
      case 'RENFE':
          result="renfe"
        break;
      case 'Taxi/VTC':
          result="karhoo"
        break;
      case 'Movitaxi':
            result="movitaxi"
        break;
      case 'Bolt':
          result="bolt"
        break;
      case 'Tier':
          result="tier"
        break;
      case 'Cooltra':
          result="cooltra"
        break;
    
      default:
        result=""
        break;
    }
  
    return result
  
  }

  /**
 * Funcion para convertir el precio string a numerico
 * @param price
 * @returns
 */
export function priceStringToNumber(price: any) {
    return parseInt(price.replace(",", "")) / 100;
  }
  
  /**
   * Funcion para convertir el precio string a numerico
   * @param price
   * @returns
   */
  export function priceStringToNumber2(price: any) {
    return price.replace(/[^0-9]+/g, "") / 100;
  }